import React from 'react';
import PropTypes from 'prop-types';
import { useMutation, useQueryClient } from 'react-query';
import Menu from '@mui/material/Menu';
import ListSubheader from '@mui/material/ListSubheader';
import List from '@mui/material/List';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemText from '@mui/material/ListItemText';

import { MdFileCopy, MdDelete } from 'react-icons/md';
import { useGlobalData } from '../context/globalData';
import { createMessage, createMessageData } from '../api/ticker';
import { useNotification } from '../context/notification';

function MenuContext(props) {
  const { globalData } = useGlobalData();
  const { contextMenu, setContextMenu, carousel, handleDelete, list, selectedItems, contextName, selectedMessage,
    showOkPopup } = props;
  const queryClient = useQueryClient();
  // const listCarousels = globalData.carousels.filter(
  //   (item) => item.languageID === carousel.languageID && item.carouselID !== carousel.carouselID && item.type === 1,
  // );
  const listCarousels = globalData.carousels.filter(
    (item) => item.languageID === carousel.languageID && item.type === 1,
  );
  const urgentCarousel = globalData.carousels.filter((x) => x.languageID === carousel.languageID && x.type === 2)[0];

  const template = globalData.templates.find(
    (item) => item.languageID === carousel.languageID && item.type === 1,
  );
  const { addNotification } = useNotification();

  const { mutate: postMessageData } = useMutation((data) => createMessageData(data), {
    onSuccess: () => {
      queryClient.invalidateQueries('tickerData');
      queryClient.invalidateQueries('xmlData');
      setContextMenu(null);
      addNotification({ message: `Message copié` });
    },
    onError: (err) => {
      addNotification({ message: `Une erreur est survenue lors de la copie du message ${err.message}`, severity: 'error' });
    },
  });

  const { mutate: postMessage } = useMutation((data) => createMessage(data), {
    onSuccess: (res) => {
      const currentMessage = list.filter((msg) => msg.messageID === res.copyID)[0];
      const messageDataID = Math.floor(1 + Math.random() * (99999 - 1));
      for (let index = 0; index < currentMessage.messageData.length; index++) {
        const item = currentMessage.messageData[index];
        const body = {
          ...item,
          messageID: res.messageID,
          messageDataID: messageDataID + index,
        };
        postMessageData(body);
      }
    },
    onError: (err) => {
      addNotification({ message: `Une erreur est survenue lors de la création du message ${err.message}`, severity: 'error' });
    },
  });

  const handleCopyToUrgentMessage = () => {
    for (let index = 0; index < selectedItems.length; index++) {
      const itemID = selectedItems[index];
      const currentMessage = list.filter((msg) => msg.messageID === itemID)[0];
      const messageID = Math.floor(1 + Math.random() * (99999 - 1));

      postMessage({
        ...currentMessage,
        carouselID: urgentCarousel.carouselID,
        position: 0,
        messageID,
        copyID: currentMessage.messageID,
        isLive: false,
        isActive: false
      });
    }
  };
  
  const handleCopyAllMessage = (dest) => {
    const visibleItems = list.filter(x=> x.isVisible);
    for (let index = 0; index < visibleItems.length; index++) {
      const item = visibleItems[index];
      const messageID = Math.floor(1 + Math.random() * (99999 - 1));

      postMessage({
        ...item,
        carouselID: dest.carouselID,
        position: 0,
        messageID,
        copyID: item.messageID,
        isLive: false,
        isActive: false
      });
    }
  };

  const handleCopyMessage = (dest) => {

    for (let index = 0; index < selectedItems.length; index++) {
      const itemID = selectedItems[index];
      const currentMessage = list.filter((msg) => msg.messageID === itemID)[0];
      const messageID = Math.floor(1 + Math.random() * (99999 - 1));

      postMessage({
        ...currentMessage,
        carouselID: dest.carouselID,
        position: 0,
        messageID,
        copyID: currentMessage.messageID,
        isLive: false,
        isActive: false
      });
    }
  };
  const handleToNormalMessage = (dest) => {
    for (let index = 0; index < selectedItems.length; index++) {
      const itemID = selectedItems[index];
      const currentMessage = list.filter((msg) => msg.messageID === itemID)[0];
      const messageID = Math.floor(1 + Math.random() * (99999 - 1));

      postMessage({
        ...currentMessage,
        carouselID: dest.carouselID,
        position: currentMessage.position,
        messageID,
        copyID: currentMessage.messageID,
        isLive: currentMessage.isLive,
        isActive: false,
        templateType: 1,
        templateID: template.templateID
      });

      handleDelete(itemID);
    }
  };
  const deleteSelectedItems = () => {
    for (let index = 0; index < selectedItems.length; index++) {
      const id = selectedItems[index];
      handleDelete(id);
    }

    setContextMenu(null);
  }

  return (
    <Menu
      className="contextMenu"
      MenuListProps={{ disablePadding: true }}
      open={contextMenu !== null}
      onClose={() => setContextMenu(null)}
      anchorReference="anchorPosition"
      anchorPosition={contextMenu !== null ? { top: contextMenu.mouseY, left: contextMenu.mouseX } : undefined}
    >
      <List
        component="nav"
        disablePadding
        aria-labelledby="nested-list-subheader"
        subheader={
          <ListSubheader component="div" id="nested-list-subheader">
            Options
          </ListSubheader>
        }
      >
        <List component="div" disablePadding>
          {selectedMessage.templateType === 2 &&
            listCarousels.map((item) => (
              <ListItemButton
                key={`destination_${item.carouselID}`}
                className="space-x-2"
                onClick={() => (carousel.type === 2 || carousel.type === 5) 
                  ? handleCopyMessage(item) : handleToNormalMessage(item)}
              >
                <MdFileCopy color="white" size={20}/>
                <ListItemText
                  primary={
                    (carousel.type === 2 || carousel.type === 5) ? (
                      <>
                        Copier dans l&apos;onglet{' '}
                        <span className="italic font-bold">{item.label?.toUpperCase()}</span>
                      </>
                    ) : (
                      <>
                        Passer en{' '}
                        <span className="italic font-bold">{item.label?.toUpperCase()}</span>
                      </>
                    )
                  }
                />
              </ListItemButton>
            ))}
        </List>
        <List component="div" disablePadding>
          {selectedMessage.templateType === 2 && carousel.type === 2 &&
            listCarousels.map((item) => (
              <ListItemButton
                key={`destination_${item.carouselID}`}
                className="space-x-2"
                onClick={() => handleCopyAllMessage(item)}
              >
                <MdFileCopy color="white" size={20} />
                <ListItemText
                  primary={
                    <>
                      Copier tous les messages dans l&apos;onglet{' '}
                      <span className="italic font-bold">{item.label?.toUpperCase()}</span>
                    </>
                  }
                />
              </ListItemButton>
            ))}
          {selectedMessage.templateType === 2 && selectedMessage.isVisible && carousel.type === 1 ?
              (<ListItemButton
                className="space-x-2"
                onClick={() => handleCopyToUrgentMessage()}
              >
                <MdFileCopy color="white" />
                <ListItemText
                  primary={
                    <>
                      Copier dans l&apos;onglet{' '}
                      <span className="italic font-bold">{`${urgentCarousel?.label?.toUpperCase()}`}</span>
                    </>
                  }
                />
              </ListItemButton>)
              : null
          }
        </List>
        <ListItemButton
          onClick={() => {
            if (!carousel.isActive || (contextName === 'antenne' && list.length - selectedItems.length > 0) || contextName !== 'antenne') {
              deleteSelectedItems();
            } else {
              setContextMenu(null);
              showOkPopup("Une liste antenne active ne peut être vide. Pour supprimer le message, passer le carrousel en OFF.");
            }
            setContextMenu(null);
          }}
          className="opt-delete space-x-2"
        >
          <MdDelete className="danger" size={20} />
          <ListItemText primary="Supprimer" />
        </ListItemButton>
      </List>

    </Menu>
  );
}

MenuContext.propTypes = {
  contextMenu: PropTypes.object,
  list: PropTypes.array,
  selectedItems: PropTypes.array,
  carousel: PropTypes.object,
  setContextMenu: PropTypes.func,
  handleDelete: PropTypes.func,
  contextName: PropTypes.string,
  showOkPopup: PropTypes.func,
  selectedMessage: PropTypes.array
};

MenuContext.defaultProps = {
  contextMenu: {},
  list: [],
  selectedItems: [],
  selectedMessage: [],
  carousel: {},
  setContextMenu: () => { },
  handleDelete: () => { },
  contextName: '',
  showOkPopup: () => { }
};

export default MenuContext;
